<template>
<div class="psychologists">
  <section class="preview">
    <div class="container">
      <div class="preview__content">
        <div class="preview__description">
          <h1 class="preview__title">{{
              $vuetify.lang.t("$vuetify.view.psychologists.preview.mainTitle")
            }}</h1>
          <span class="preview__subtitle">{{
              $vuetify.lang.t("$vuetify.view.psychologists.preview.subtitle")
            }}</span>
        </div>
        <div class="preview__picture">
          <img class="preview__main-img" src="@/assets/images/psychologists/1.png" alt="talks">
        </div>
      </div>
      <div class="border-bottom"></div>

      <div class="pt-4 pb-2 d-flex">
        <div class="filters-wrapper flex-grow-1 d-flex flex-wrap">
          <v-menu
            v-model="symptoms_menu"
            :close-on-content-click="false"
            offset-y
            max-width="350"
            min-width="350"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="filter-btn-styles filter-btn rounded-lg"
                v-bind="attrs"
                v-on="on"
              >
                {{$vuetify.lang.t("$vuetify.view.psychologists.filters.symptoms")}}
                <v-icon right>mdi-chevron-down</v-icon>
              </div>
            </template>

            <v-card>
              <v-card-text class="scroll-area">
                <div
                  class="d-flex flex-column flex-wrap"
                  v-for="(items, i) in filters"
                  :key="i"
                >
                  <h3 class="symptoms-block_title pt-3 pb-1">
                    {{ $vuetify.lang.t(`$vuetify.view.psychologists.specialization.${i}`) }}
                  </h3>
                    <v-checkbox
                      v-for="(item, i)  in items"
                      :key="i"
                      v-model="selected_symptoms"
                      :label="item"
                      :value="i"
                      hide-details
                      dense
                    />
                </div>
                
              </v-card-text>

              <v-divider />

              <v-card-actions class="justify-end sticky-bottom">
                <v-btn color="primary" block @click="applyFiltersAndClose">
                  {{$vuetify.lang.t("$vuetify.view.psychologists.filters.show_psychologists")}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            v-model="specializations_menu"
            :close-on-content-click="false"
            offset-y
            max-width="350"
            min-width="350"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="filter-btn-styles filter-btn rounded-lg"
                v-bind="attrs"
                v-on="on"
              >
                {{$vuetify.lang.t("$vuetify.view.psychologists.filters.specialization")}}
                <v-icon right>mdi-chevron-down</v-icon>
              </div>
            </template>

            <v-card>
              <v-card-text class="scroll-area">
                <v-checkbox
                  v-for="(item, i) in main_treatment_method_Items"
                  :key="i + item.id"
                  v-model="selected_specializations"
                  :label="item.title"
                  :value="item.id"
                  hide-details
                  dense
                />
              </v-card-text>

              <v-divider />

              <v-card-actions class="justify-end sticky-bottom">
                <v-btn color="primary" block @click="applyFiltersAndClose">
                  {{$vuetify.lang.t("$vuetify.view.psychologists.filters.show_psychologists")}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-menu
            v-model="sex_menu"
            :close-on-content-click="false"
            offset-y
            max-width="350"
            min-width="350"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="filter-btn-styles filter-btn rounded-lg"
                v-bind="attrs"
                v-on="on"
              >
                {{$vuetify.lang.t("$vuetify.view.psychologists.filters.sex")}}
                <v-icon right>mdi-chevron-down</v-icon>
              </div>
            </template>

            <v-card>
              <v-card-text class="scroll-area">
                <v-checkbox
                  v-for="(item, i) in sex_options"
                  :key="i + item.id"
                  v-model="selected_sex"
                  :label="item.title"
                  :value="item.id"
                  hide-details
                  dense
                />
              </v-card-text>

              <v-divider />

              <v-card-actions class="justify-end sticky-bottom">
                <v-btn color="primary" block @click="applyFiltersAndClose">
                  {{$vuetify.lang.t("$vuetify.view.psychologists.filters.show_psychologists")}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-menu
            v-model="type_of_consultation_menu"
            :close-on-content-click="false"
            offset-y
            max-width="340"
            min-width="340"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="filter-btn-styles filter-btn rounded-lg"
                v-bind="attrs"
                v-on="on"
              >
                <span>{{$vuetify.lang.t("$vuetify.view.common.typeOfConsultation")}}</span>
                <v-icon right>mdi-chevron-down</v-icon>
              </div>
            </template>

            <v-list>
              <v-list-item @click="setConsultationType(1)">
                <v-list-item-title>{{ $vuetify.lang.t("$vuetify.view.common.forMyself") }}</v-list-item-title>
                <v-icon v-if="1 === getSelectedConsultationType" right color="primary">
                  mdi-check
                </v-icon>
              </v-list-item>
              <v-list-item @click="setConsultationType(2)">
                <v-list-item-title>{{ $vuetify.lang.t("$vuetify.view.common.couples") }}</v-list-item-title>
                <v-icon v-if="2 === getSelectedConsultationType" right color="primary">
                  mdi-check
                </v-icon>
              </v-list-item>
            </v-list>
          </v-menu>
          <div
            class="open-filters-btn filter-btn-styles rounded-lg"
            @click="showFiltersModal = true"
          >
            {{$vuetify.lang.t("$vuetify.view.psychologists.filters.filters")}}
          </div>
        </div>
        <div>
          <v-menu
            v-model="sort_options_menu"
            :close-on-content-click="false"
            offset-y
            max-width="340"
            min-width="340"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="filter-btn-styles rounded-lg"
                v-bind="attrs"
                v-on="on"
              >
                <span class="limited-width-title">{{selected_sort_option.title}}</span>
                <v-icon right>mdi-chevron-down</v-icon>
              </div>
            </template>

            <v-list>
              <v-list-item
                v-for="option in sort_options"
                :key="option.id"
                @click="selectSortOption(option)"
              >
                <v-list-item-title>{{ option.title }}</v-list-item-title>
                <v-icon v-if="option.id === selected_sort_option.id" right color="primary">
                  mdi-check
                </v-icon>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <div class="d-flex selected-filters mt-1" v-if="selected_filters_list_symptoms.length || selected_filters_list_specializations.length || selected_filters_list_sex.length">
        <div class="d-flex flex-grow-1 selected-filters_wrapper">
          <div v-for="item in selected_filters_list_symptoms" :key="item.id" class="d-flex align-center py-1 my-2 selected-filter">
            <span class="mr-1">{{item.title}}</span><div class="remove" @click="unselectSymptom(item.id)"><v-icon>mdi-close</v-icon></div>
          </div>
          <div v-for="item in selected_filters_list_specializations" :key="item.id" class="d-flex align-center py-1 my-2 selected-filter">
            <span class="mr-1">{{item.title}}</span><div class="remove" @click="unselectSpecialization(item.id)"><v-icon>mdi-close</v-icon></div>
          </div>
          <div v-for="item in selected_filters_list_sex" :key="item.id" class="d-flex align-center py-1 my-2 selected-filter">
            <span class="mr-1">{{item.title}}</span><div class="remove" @click="unselectSex(item.id)"><v-icon>mdi-close</v-icon></div>
          </div>
        </div>
        <div class="pl-3 clear-filters__wrapper">
          <span class="clear-filters py-1 my-2" @click="clearFilters()">{{$vuetify.lang.t("$vuetify.view.psychologists.filters.clear")}}</span>
        </div>
      </div>
    </div>
    <div class="container full-width psychologists_wrapper">
      <preloader
        :isLoad="isLoad">
      </preloader>
      <cards-section
        :isLoad="isLoad">
      </cards-section>

      <pagination
        @loadEvent="isLoad = !isLoad"
        :selected_symptoms="selected_symptoms"
        :selected_specializations="selected_specializations"
        :selected_sex="selected_sex"
        :selected_sort_option="selected_sort_option"
        :lastPage="lastPage">
      </pagination>
    </div>
  </section>



  <v-dialog v-model="showFiltersModal" max-width="600px" persistent>
    <v-card class="modal-card">
      <!-- Заголовок -->
      <v-card-title>
        <span class="headline">{{$vuetify.lang.t("$vuetify.view.psychologists.filters.filters")}}</span>
      </v-card-title>

      <!-- Контент, який скролиться -->
      <v-card-text class="modal-scrollable-content">
        <v-expansion-panels v-model="panels" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div class="d-flex align-center justify-space-between w-100">
                <div class="d-flex align-center justify-space-between flex-grow-1">
                  <span>{{$vuetify.lang.t("$vuetify.view.psychologists.filters.symptoms")}}</span>
                  <v-badge
                    :content="selected_symptoms.length"
                    color="primary"
                    v-if="selected_symptoms.length"
                    bordered
                    overlap
                    class="ml-2 mr-4 count-badge"
                  >
                    <span></span>
                  </v-badge>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div
                  class="d-flex flex-column flex-wrap"
                  v-for="(items, i) in filters"
                  :key="i"
                >
                <h3 class="symptoms-block_title pt-3 pb-1">
                  {{ $vuetify.lang.t(`$vuetify.view.psychologists.specialization.${i}`) }}
                </h3>
                  <v-checkbox
                    v-for="(item, i)  in items"
                    :key="i"
                    v-model="selected_symptoms"
                    :label="item"
                    :value="i"
                    hide-details
                    dense
                  />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div class="d-flex align-center justify-space-between w-100">
                <div class="d-flex align-center justify-space-between flex-grow-1">
                  <span>{{$vuetify.lang.t("$vuetify.view.psychologists.filters.specialization")}}</span>
                  <v-badge
                    :content="selected_specializations.length"
                    color="primary"
                    v-if="selected_specializations.length"
                    bordered
                    overlap
                    class="ml-2 mr-4 count-badge"
                  >
                    <span></span>
                  </v-badge>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-checkbox
                v-for="(item, i) in main_treatment_method_Items"
                :key="i + item.id"
                v-model="selected_specializations"
                :label="item.title"
                :value="item.id"
                hide-details
                dense
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
          
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div class="d-flex align-center justify-space-between w-100">
                <div class="d-flex align-center justify-space-between flex-grow-1">
                  <span>{{$vuetify.lang.t("$vuetify.view.psychologists.filters.sex")}}</span>
                  <v-badge
                    :content="selected_sex.length"
                    color="primary"
                    v-if="selected_sex.length"
                    bordered
                    overlap
                    class="ml-2 mr-4 count-badge"
                  >
                    <span></span>
                  </v-badge>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-checkbox
                v-for="(item, i) in sex_options"
                :key="i + item.id"
                v-model="selected_sex"
                :label="item.title"
                :value="item.id"
                hide-details
                dense
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div class="d-flex align-center justify-space-between w-100">
                <div class="d-flex align-center justify-space-between flex-grow-1">
                  <span>{{$vuetify.lang.t("$vuetify.view.common.typeOfConsultation")}}</span>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-radio-group
                :value="getSelectedConsultationType"
                @change="setConsultationType"
              >
                <v-radio
                  :label="$vuetify.lang.t('$vuetify.view.common.forMyself')"
                  :value="1"
                />

                <v-radio
                  :label="$vuetify.lang.t('$vuetify.view.common.couples')"
                  :value="2"
                />
              </v-radio-group>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </v-card-text>

      <!-- Футер з кнопками, який не скролиться -->
      <v-divider></v-divider>
      <v-card-actions class="modal-actions">
        <v-btn block class="ml-0" color="primary" @click="applyFiltersAndClose">{{$vuetify.lang.t("$vuetify.view.psychologists.filters.show")}}</v-btn>
        <v-btn block class="ml-0" color="secondary" @click="showFiltersModal = false">{{$vuetify.lang.t("$vuetify.view.psychologists.filters.close")}}</v-btn>
        <v-btn block text class="ml-0" @click="clearFilters()">{{$vuetify.lang.t("$vuetify.view.psychologists.filters.clear")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import CardsSection from '@/components/dashboard/patientDashboard/PatientPsychologist/CardsSection'
import Preloader from '@/components/dashboard/patientDashboard/PatientPsychologist/Preloader'
import Pagination from '@/components/dashboard/patientDashboard/PatientPsychologist/Pagination'
export default {
  name: 'ConnectComponent',
  components: {
    Pagination,
    Preloader,
    CardsSection
  },
  data () {
    return {
      lastPage: null,
      isLoad: false,

      showFiltersModal: false,
      symptoms_menu: false,
      specializations_menu: false,
      sort_options_menu: false,
      type_of_consultation_menu: false,
      sex_menu: false,
      panels: [],
      selected_symptoms: [],
      selected_filters_list_symptoms: [],
      selected_specializations: [],
      selected_filters_list_specializations: [],
      selected_sex: [],
      selected_filters_list_sex: [],
      sex_options: [
        {
          id: 0,
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.sex_options.female"
          ),
        },
        {
          id: 1,
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.sex_options.male"
          ),
        }
      ],
      selected_sort_option: {
        title: this.$vuetify.lang.t(
          "$vuetify.view.psychologists.sort_options.default"
        ),
        id: "default",
      },
      sort_options: [
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.sort_options.default"
          ),
          id: "default",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.sort_options.exp_desc"
          ),
          id: "exp_desc",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.sort_options.price_desc"
          ),
          id: "price_desc",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.sort_options.price_asc"
          ),
          id: "price_asc",
        },
      ],
      main_treatment_method_Items: [
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.art_therapy"
          ),
          id: "art_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.client_centered_psychotherapy"
          ),
          id: "client_centered_psychotherapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.cognitive_behavioral_therapy"
          ),
          id: "cognitive_behavioral_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.body_therapy"
          ),
          id: "body_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.psychoanalysis"
          ),
          id: "psychoanalysis",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.jungian_analysis"
          ),
          id: "jungian_analysis",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.transactional_analysis"
          ),
          id: "transactional_analysis",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.family_therapy"
          ),
          id: "family_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.gestalt_therapy"
          ),
          id: "gestalt_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.psychodrama"
          ),
          id: "psychodrama",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.analytical_psychology"
          ),
          id: "analytical_psychology",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.symboldrama"
          ),
          id: "symboldrama",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.existential_analysis"
          ),
          id: "existential_analysis",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.nlp"
          ),
          id: "nlp",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.positive_psychotherapy"
          ),
          id: "positive_psychotherapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.emdr"
          ),
          id: "emdr",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.schema_therapy"
          ),
          id: "schema_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.emotional_imagery_therapy"
          ),
          id: "emotional_imagery_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.integrative_approach"
          ),
          id: "integrative_approach",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.act_therapy"
          ),
          id: "act_therapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.hypnotherapy"
          ),
          id: "hypnotherapy",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.coaching"
          ),
          id: "coaching",
        },
        {
          title: this.$vuetify.lang.t(
            "$vuetify.view.psychologists.specialization.logotherapy"
          ),
          id: "logotherapy",
        },
      ]
    }
  },
  computed: {
    filters () {
      return this.$store.getters['user/getFiltersList']
    },
    getSelectedConsultationType () {
      return this.$store.getters['consultation_type/getSelectedConsultationType']
    },
  },
  beforeMount () {
    this.isLoad = true
    this.$store.dispatch('user/getPsychologistFilter')
    this.$store.dispatch('user/getPsychologists', { page: 1, selected_symptoms: [], selected_specializations: [], selected_sex: [], selected_sort_option: this.selected_sort_option.id, consultation_type_id: this.getSelectedConsultationType })
      .then((response) => {
        this.lastPage = response.data.meta.last_page
        this.isLoad = false
      })
  },
  methods: {
    setConsultationType(consultation_type) {
      this.$store.dispatch('consultation_type/setConsultationType', consultation_type)
      .then(() => {
        this.applyFiltersAndClose();
      })
      
    },
    selectSortOption(sort_option) {
      this.selected_sort_option = sort_option;
      this.applyFiltersAndClose();
    },
    unselectSymptom(id) {
      this.selected_symptoms = this.selected_symptoms.filter(v => v !== id);
      this.applyFiltersAndClose();
    },
    unselectSpecialization(id) {
      this.selected_specializations = this.selected_specializations.filter(v => v !== id);
      this.applyFiltersAndClose();
    },
    unselectSex(id) {
      this.selected_sex = this.selected_sex.filter(v => v !== id);
      this.applyFiltersAndClose();
    },
    clearFilters() {
      this.selected_symptoms = [];
      this.selected_specializations = [];
      this.selected_sex = [];
      this.panels = [];
      this.applyFiltersAndClose();
    },
    applyFiltersAndClose() {
      this.isLoad = !this.isLoad
      this.$store.dispatch('user/getPsychologists', { page: 1, selected_symptoms: this.selected_symptoms, selected_specializations: this.selected_specializations, selected_sex: this.selected_sex, selected_sort_option: this.selected_sort_option.id, consultation_type_id: this.getSelectedConsultationType })
        .then((response) => {
          this.lastPage = response.data.meta.last_page
          this.symptoms_menu = false
          this.sort_options_menu = false
          this.specializations_menu = false
          this.sex_menu = false
          this.showFiltersModal = false
          this.type_of_consultation_menu = false
          this.isLoad = !this.isLoad

          

          this.selected_filters_list_symptoms = [];
          Object.keys(this.filters).forEach(key => {
            let items = this.filters[key]
            Object.keys(items).forEach(symptom => {
              if (this.selected_symptoms.includes(symptom)) {
                this.selected_filters_list_symptoms.push({
                  id: symptom,
                  title: items[symptom]
                });
              }
            });
          });

          this.selected_filters_list_specializations = [];
          this.main_treatment_method_Items.forEach(item => {
            if (this.selected_specializations.includes(item.id)) {
              this.selected_filters_list_specializations.push({
                id: item.id,
                title: item.title
              });
            }
          });

          this.selected_filters_list_sex = [];
          this.sex_options.forEach(item => {
            if (this.selected_sex.includes(item.id)) {
              this.selected_filters_list_sex.push({
                id: item.id,
                title: item.title
              });
            }
          });
        })
    },
  }

}
</script>

<style lang="scss" scoped>
.count-badge {
  margin-bottom: 2px;
}
.modal-card {
  display: flex;
  flex-direction: column;
  max-height: 90vh; /* адаптивна висота */
}

.modal-scrollable-content {
  overflow-y: auto;
  flex: 1 1 auto;
}

.modal-actions {
  flex-direction: column;
  row-gap: 12px;
}

.filters-wrapper {
  column-gap: 25px;
  row-gap: 14px;
}
.clear-filters {
  display: block;
  color: #00A3B7;
  cursor: pointer;
}
.selected-filters_wrapper {
  column-gap: 16px;
  flex-wrap: wrap;
}

.selected-filters_wrapper .remove:hover {
  cursor: pointer;

  .v-icon {
    color: #a3a3a3;
  }
}

.psychologists_wrapper {
  background: #D9E4EB;
}

.filter-btn-styles {
  background: #D9E4EB;
  padding: 10px 18px;
  color: #575756;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.filter-btn-styles .limited-width-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 127px;
}

.scroll-area {
  max-height: 242px;
  overflow-y: auto;
  padding-top: 4px;
  padding-bottom: 4px;
}

.preview {
  /* * {
    font-family: "Inter", sans-serif;
  } */

  padding: 60px 0 15px;

  .border-bottom {
    border-bottom: 2px solid #00A3B7;
    min-width: 100%;
    margin-left: -12px;
    margin-right: -12px;
    margin-top: -2px;
    position: relative;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    gap: 90px;
  }

  &__description {
    //text-align: center;
    max-width: 440px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //align-items: center;
    //padding-top: 50px;
  }

  &__title {
    max-width: 420px;
    font-size: 2rem;
    line-height: normal;
    font-weight: 400;
    color: $darkGrey;
  }

  &__secondary-img {
    position: relative;
    top: 1.8rem;
    left: 30px;
    max-width: 290px;
  }

  &__subtitle {
    margin-top: 42px;
    max-width: 400px;
    font-weight: normal;
    font-size: 1.25rem;
    color: $darkTextColor;
  }

  &__main-btn {
    margin: 0 auto;
  }

  &__picture {
    display: flex;
    align-items: flex-end;
    max-width: 550px;
  }

  &__block {
    display: grid;
    margin-top: 100px;
    margin-right: -90px;
    grid-template-columns: 320px auto;
    grid-auto-rows: 1fr;
  }

  &__link {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
  }

  &__decor-text {
    font-size: 1.4rem;
    margin-top: 10px;
    line-height: 22px;
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
  }

  &__arrow {
    display: flex;
    margin-left: 10px;
    align-items: center;
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;
  }

  &__arrow img {
    height: 80px;
  }

  &__main-img {
    width: 100%;
    height: auto;
    max-width: 600px;
    max-height: 600px;
  }

  &__footer {
    border-top: 2px solid $lightColor;
    margin-top: 50px;
  }

  &__dignity-list {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    list-style: none;
    text-align: center;
    color: $darkTextColor;
    padding-left: 0;
  }

  &__dignity-item {
    flex-basis: 235px;
  }

  &__dignity-item--width {
    flex-basis: 175px;
  }

  &__dignity-title {
    color: $darkTextColor;
    font-size: 1.4rem;
    font-weight: normal;
  }

  &__addition {
    color: $darkTextColor;
    font-size: 1rem;
  }
}

.open-filters-btn {
  display: none;
}

@media screen and (max-width: 768px) {
  /* .selected-filters_wrapper {
    flex-wrap: nowrap;
    overflow: auto;
  }
  .selected-filters_wrapper .selected-filter {
    flex-shrink: 0;
  } */
  .selected-filters .clear-filters__wrapper {
    display: none;
  }

  .preview__content {
    flex-wrap: wrap;
    justify-content: center;
  }

  .filter-btn {
    display: none;
  }

  .open-filters-btn {
    display: block;
  }
}
</style>
